import { TCreateComboGroupVisibleForm, TTypeOfCreateComboGroupModalWindow } from './createComboGroupContext';
import { IItemForGetShortInfo, TLanguageIDs, IMenuTranslation, IDefaultLanguage, ICreateComboGroup } from 'types';

export enum CreateComboGroupActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_CUSTOMER = 'SET_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_RESTAURANTS = 'SET_RESTAURANTS',
	SET_FETCHED_DISHES = 'SET_FETCHED_DISHES',
	SET_DISHES = 'SET_DISHES',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_FETCHED_COMBO_ITEMS = 'SET_FETCHED_COMBO_ITEMS',
	SET_COMBO_ITEMS = 'SET_COMBO_ITEMS',
	CHANGE_UPPER_LIMIT = 'CHANGE_UPPER_LIMIT',
	CHANGE_LOWER_LIMIT = 'CHANGE_LOWER_LIMIT',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateComboGroupActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TCreateComboGroupVisibleForm;
	};
}

interface ISetFetchedCustomers {
	type: CreateComboGroupActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetCustomer {
	type: CreateComboGroupActionTypes.SET_CUSTOMER;
	payload: {
		customer: Nullable<string>;
	};
}

interface ISetFetchedRestaurants {
	type: CreateComboGroupActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfo[];
	};
}

interface ISetRestaurants {
	type: CreateComboGroupActionTypes.SET_RESTAURANTS;
	payload: {
		restaurants: string[];
	};
}

interface ISetFetchedDishes {
	type: CreateComboGroupActionTypes.SET_FETCHED_DISHES;
	payload: {
		dishes: IItemForGetShortInfo[];
	};
}

interface ISetDishes {
	type: CreateComboGroupActionTypes.SET_DISHES;
	payload: {
		dishes: string[];
	};
}

interface IChangeName {
	type: CreateComboGroupActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetFetchedComboItems {
	type: CreateComboGroupActionTypes.SET_FETCHED_COMBO_ITEMS;
	payload: {
		comboItems: IItemForGetShortInfo[];
	};
}

interface ISetComboItems {
	type: CreateComboGroupActionTypes.SET_COMBO_ITEMS;
	payload: {
		comboItems: string[];
	};
}

interface IChangeUpperLimit {
	type: CreateComboGroupActionTypes.CHANGE_UPPER_LIMIT;
	payload: {
		upperLimit: string;
	};
}

interface IChangeLowerLimit {
	type: CreateComboGroupActionTypes.CHANGE_LOWER_LIMIT;
	payload: {
		lowerLimit: string;
	};
}

interface ISetFetchedTranslation {
	type: CreateComboGroupActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: IMenuTranslation[];
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface ISetTranslationTab {
	type: CreateComboGroupActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: TLanguageIDs | null;
	};
}

interface IChangeTranslation {
	type: CreateComboGroupActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface ISetDataForSubmit {
	type: CreateComboGroupActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateComboGroup | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateComboGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateComboGroupModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateComboGroupActionTypes.RESET_FIELDS;
}

export type TCreateComboGroupAction =
	| IChangeVisibleForm
	| ISetFetchedCustomers
	| ISetCustomer
	| ISetFetchedRestaurants
	| ISetRestaurants
	| ISetFetchedDishes
	| ISetDishes
	| IChangeName
	| ISetFetchedComboItems
	| ISetComboItems
	| IChangeUpperLimit
	| IChangeLowerLimit
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
